import FilterForm from 'assets/components/filters/filterForm/FilterForm';
import ThemeFilterFormDrawer from 'assets/components/filters/filterForm/themes/Theme.FilterForm.Drawer';
import Icon from 'assets/components/icon/Icon';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import { getLocales } from 'assets/locales/Locale';
import { usePostingAccountProvider } from '../Finance.PostingAccount.Hooks';

export default function FinancePostingAccountFilters() {
  const { lang } = getLocales();
  const { listApi, productApi } = usePostingAccountProvider();

  return (
    <FilterForm
      subcomponents={ThemeFilterFormDrawer}
      search={listApi.body?.search}
      onSearch={(search) => listApi.execute((body) => ({ ...body, search, offset: 0 }))}
      onSortById={(sort) => listApi.execute((body) => ({ ...body, ...sort }))}
      filters={listApi.body ?? {}}
      onFilter={(newFilters) =>
        listApi.execute((prev) => ({
          ...prev,
          ...newFilters,
          offset: 0,
        }))
      }
      onReset={() => {
        listApi.reset();
      }}
      onOpen={() => {
        if (!productApi.payload) productApi.execute((body) => body);
      }}
      render={({ tempFilters, setFilters }) => {
        return (
          <>
            <SelectInput
              name="productId"
              label={lang.products}
              data={productApi.payload?.data.map((item) => ({
                ...item.displayInfo,
                icon: <Icon class="fas-box" />,
              }))}
              isMultiselect
              value={tempFilters?.productId}
              onChange={({ productId }) => setFilters({ ...tempFilters, productId })}
              icon={<Icon class="fas-box" />}
            />
          </>
        );
      }}
    />
  );
}
